import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import en from "@/assets/locales/en.json";
import ru from "@/assets/locales/ru.json";
import uz from "@/assets/locales/uz.json";

const Languages = ["uz", "ru", "en"];

void i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    /**
     * `lng` ATAYLAB yo'q.
     *
     * U berilganda i18next aniqlagichni umuman ishga tushirmaydi: o'rnatilgan
     * `i18next-browser-languagedetector` hech qachon ishlamas, birinchi marta
     * kirgan har qanday odam o'zbekchani ko'rar va `?lng=ru` hech narsa
     * qilmasdi. Endi tartib quyidagicha: URL → saqlangan tanlov → brauzer
     * sozlamasi, topilmasa `fallbackLng`.
     */
    fallbackLng: Languages,
    supportedLngs: Languages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["querystring", "localStorage", "cookie", "navigator", "htmlTag"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage", "cookie"],
      excludeCacheFor: ["cimode"],
    },
    ns: ["translation"],
    defaultNS: "translation",
    resources: {
      ru: {
        translation: ru,
      },
      uz: {
        translation: uz,
      },
      en: {
        translation: en,
      },
    },
    react: {
      useSuspense: false,
    },
  });

export default i18next;
